module.exports = __webpack_public_path__ + "assets/6d0aa96b4163d2eec5def970b3045c8d.png";